import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { Controller } from 'react-hook-form';

interface PlatformSectionProps {
  control: any;
  t: (key: string) => string;
}

export const PlatformSection = ({ control, t }: PlatformSectionProps) => (
  <Controller
    name="os"
    control={control}
    defaultValue="AOS"
    render={({ field }) => (
      <RadioGroup {...field} row>
        <FormControlLabel 
          value="AOS" 
          control={<Radio />} 
          label={t('android')} 
        />
        <FormControlLabel 
          value="IOS" 
          control={<Radio />} 
          label={t('ios')} 
        />
      </RadioGroup>
    )}
  />
);